





















































// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ElementResultsTooltip from '@/components/elements/ElementResultsTooltip.vue';
import ChartStandardScoringSections from '@/components/charts/standard/ChartStandardScoringSections.vue';
import { usePodocoreModule } from '@/plugins/podocore';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'PatientResultsScoring',
  components: {
    ElementResultsTooltip,
    ChartStandardScoringSections
  },
  props: {
    analysis: {
      type: Object,
      required: true
    },
    showParameters: {
      type: Boolean,
      default: true
    }
  },
  setup(properties) {
    const busModule = usePodocoreModule('bus');

    const GVIParameters = computed(() => {
      return [
        {
          id: 'walking_step_length_variability_score',
          name: 'commons.standards.step-length',
          desc: 'commons.standards.step-length.desc',
          indicator: {
            left: properties.analysis.metrics.aggregates.walking_step_length_variability_score.left_foot
              .indicator,
            right:
              properties.analysis.metrics.aggregates.walking_step_length_variability_score.right_foot
                .indicator
          }
        },
        {
          id: 'walking_step_time_variability_score',
          name: 'commons.standards.step-time',
          desc: 'commons.standards.step-time.desc',
          indicator: {
            left: properties.analysis.metrics.aggregates.walking_step_time_variability_score.left_foot
              .indicator,
            right:
              properties.analysis.metrics.aggregates.walking_step_time_variability_score.right_foot.indicator
          }
        },
        {
          id: 'walking_stance_time_variability_score',
          name: 'commons.standards.stance-time',
          desc: 'commons.standards.stance-time.desc',
          indicator: {
            left: properties.analysis.metrics.aggregates.walking_stance_time_variability_score.left_foot
              .indicator,
            right:
              properties.analysis.metrics.aggregates.walking_stance_time_variability_score.right_foot
                .indicator
          }
        },
        {
          id: 'walking_single_support_time_variability_score',
          name: 'commons.standards.single-support-time',
          desc: 'commons.standards.single-support-time.desc',
          indicator: {
            left: properties.analysis.metrics.aggregates.walking_single_support_time_variability_score
              .left_foot.indicator,
            right:
              properties.analysis.metrics.aggregates.walking_single_support_time_variability_score.right_foot
                .indicator
          }
        },
        {
          id: 'walking_stride_velocity_variability_score',
          name: 'commons.standards.stride-velocity-variability',
          desc: 'commons.standards.stride-velocity-variability.desc',
          indicator: {
            left: properties.analysis.metrics.aggregates.walking_stride_velocity_variability_score.left_foot
              .indicator,
            right:
              properties.analysis.metrics.aggregates.walking_stride_velocity_variability_score.right_foot
                .indicator
          }
        }
      ];
    });

    const onShowMore = () => {
      busModule.publish(
        busModule.events.openDialog({
          id: 'analysis-GVI',
          meta: { analysis: properties.analysis }
        })
      );
    };

    return {
      GVIParameters,
      onShowMore
    };
  }
});
